import zod from 'zod'

export const askQuestionSchema = zod.object({
  id: zod.string(),
  rawQuestion: zod.string(),
  answered: zod.boolean(),
  vector: zod.array(zod.number()),
  sourceNotes: zod.array(zod.string()),
  citedNotes: zod.array(zod.string()),
  maxCrossEncode: zod.number(),
  createdBy: zod.string().nullable(),
  isSharedWithOrganization: zod.boolean(),
  answer: zod.string().nullable(),
  parentQuestionId: zod.string().optional().nullable(),
  questionIndex: zod.number().optional().nullable(),
})

export type AskQuestion = zod.infer<typeof askQuestionSchema>
